<template>
  <div class="body">
    <div class="title">
      会员管理
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item>通讯录管理</el-breadcrumb-item>
          <el-breadcrumb-item>会员管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left"></div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item>
            <el-date-picker
              type="date"
              v-model="mingpianQuery.create_date"
              @change="Discountsearch"
              placeholder="申请日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-cascader :props="checkedData.typeOptions" @change="changList" clearable></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="审核状态" v-model="mingpianQuery.verify_status" @change="Discountsearch" style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="0" label="全部 "></el-option>
              <el-option  name="selected" :value="1" label="未审核 "></el-option>
              <el-option  name="selected" :value="2" label="已审核 "></el-option>
              <el-option  name="selected" :value="3" label="拒绝 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="会员状态" v-model="mingpianQuery.is_status" @change="Discountsearch"  style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="0" label="全部 "></el-option>
              <el-option  name="selected" :value="1" label="下架 "></el-option>
              <el-option  name="selected" :value="2" label="上架 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="排序/跳转链接/链接说明 " v-model="mingpianQuery.keyword"  @change="Discountsearch" style="min-width: 168px;width: 336px;">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <vxe-table
      border
      show-overflow
      keep-source
      ref="xTable"
      max-height="750"
      class="mytable-scrollbar"
      :data="tableData"
      align="center"
      :edit-config="{trigger: 'click', mode: 'cell', icon: 'fa fa-pencil', showStatus: true}">
      <vxe-table-column type="seq" width="60"></vxe-table-column>
      <vxe-table-column field="realname" title="姓名" width="100"></vxe-table-column>
      <vxe-table-column  title="头像" width="100">
        <template slot-scope="scope">
          <img :src="scope.row.user_facepic" alt="" style="width: 70px;height: 70px">
        </template>
      </vxe-table-column>
      <vxe-table-column field="mobile" title="手机号码" width="100"></vxe-table-column>
      <vxe-table-column title="名片认证" width="100">
        <template slot-scope="scope">
         <span :style="{'color': (scope.row.verify_status === 0 ? '#A1A1A1':scope.row.verify_status === 1 ? '#0FA838':'#E54848')}" >
            {{scope.row.verify_status === 0 ?'未认证':scope.row.verify_status === 1 ?'已认证':'拒绝'}}
         </span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="com_identity" title="身份" width="100"></vxe-table-column>
      <vxe-table-column field="com_name" title="公司名称" width="100"></vxe-table-column>
      <vxe-table-column field="create_time" title="开通时间" width="100"></vxe-table-column>
      <vxe-table-column field="vip_endtime" title="会员到期时间" width="100"></vxe-table-column>
      <vxe-table-column field="vip_surplusdays" title="会员剩余/天" width="100"></vxe-table-column>
      <vxe-table-column title="操作" min-width="200">
        <template slot-scope="scope">
          <!-- 修改按钮 -->
          <div class="row">
            <button class="huiyuananniu" @click="huiyuanxiangqingccc(scope.row)">会员资料</button>
          </div>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div v-if="pageshow">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <vxe-modal v-model="dakaihuiyuanxiangqing" title="会员资料" width="800" height="600" :mask="false" :lock-view="false" resize>
      <template #default>
        <el-row class="rowLE">
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form ref="form" :model="form" label-width="80px"  :label-position="labelPosition">
                <el-form-item label="名片头像">
                  <img :src="huiyuanxq.user_facepic" alt="" style="width: 106px;height: 106px" >
                </el-form-item>
                <el-form-item label="姓名" label-width="138px">
                  {{ huiyuanxq.realname }}
                </el-form-item>
                <el-form-item label="手机号码" label-width="138px">
                  {{ huiyuanxq.card_mobile }}
                </el-form-item>
                <el-form-item label="注册时间" label-width="138px">
                  {{ huiyuanxq.create_time }}
                </el-form-item>

              </el-form>
            </div></el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <el-form ref="form" :model="form" label-width="80px"  :label-position="labelPosition">
                <el-form-item label="会员状态" label-width="138px" >
                 <span :style="{'color': (huiyuanxq.is_vip === 0 ? '#9C9C9C':'#E54848')}" >
                    {{ huiyuanxq.is_vip === 0?'非会员':'会员' }}
                   <span v-if="huiyuanxq.is_vip === 0" style="color: #E54848">（已过期）</span>
                 </span>
                </el-form-item>
                <el-form-item label="到期时间" label-width="138px">
                  {{ huiyuanxq.vip_endtime}}
                </el-form-item>
                <el-form-item label="是否置顶" label-width="138px">
                  {{ huiyuanxq.is_top === 0?'未置顶':'已置顶' }}
                </el-form-item>
                <el-form-item label="置顶天数" label-width="138px" v-if="huiyuanxq.is_top !==0">
                  {{ huiyuanxq.istop_surplusdays}}天
                </el-form-item>
                <el-form-item label="关注数" label-width="138px" >
                  {{ huiyuanxq.follownum}}
                </el-form-item>
                <el-form-item label="认证时间" label-width="138px">
                  {{ huiyuanxq.status_time }}
                </el-form-item>
              </el-form>
            </div></el-col>
        </el-row>
      </template>
    </vxe-modal>
    <vxe-modal  title="开通记录" width="800" height="600" :mask="false" :lock-view="false" resize>
      <template #default>
        <div class="headetrxsadf">
          <div class="leftdsss">
            <div class="titleddss">
              王建国
              <span class="idss">(ID:)</span>
            </div>
          </div>
          <div class="right">
            <div class="huiyuanzhuangtai">
              会员状态
              <span class="sdadwee">
                会员
              </span>
              <span class="sadgggvv">
                (剩余498天)
              </span>
            </div>
          </div>
        </div>
        <vxe-table
          border
          show-overflow
          keep-source
          ref="xTable"
          max-height="400"
          :data="tableData"
          :edit-config="{trigger: 'click', mode: 'cell', icon: 'fa fa-pencil', showStatus: true}">
          <vxe-table-column type="seq" width="60"></vxe-table-column>
          <vxe-table-column field="id" title="开通时间"></vxe-table-column>
          <vxe-table-column field="name" title="开通时长/天"></vxe-table-column>
          <vxe-table-column field="leixing" title="收费金额/元"></vxe-table-column>
          <vxe-table-column field="dizhi" title="支付方式 "></vxe-table-column>
          <vxe-table-column field="dianhua" title="订单号"></vxe-table-column>
          <vxe-table-column field="zhuangtai" title="第三方交易号"></vxe-table-column>
        </vxe-table>
      </template>
    </vxe-modal>
</div>
</template>

<script>
import { cardlist, cardview } from '@/api/tongxunlu'
import { area, city, province } from '@/api/city'

export default {
  name: 'huiyuanguanli',
  data () {
    return {
      checkedData: {
        // sendData: ['province_name'], // 默认选中值
        typeOptions: {
          lazy: true, // 开启懒加载
          lazyLoad: this.lazyLoad
        }
      },
      total: null,
      cur_page: 1,
      pageshow: true,
      value: '',
      labelPosition: 'left',
      tableData: [],
      mingpianQuery: {
        token: sessionStorage.getItem('token'),
        create_date: '',
        verify_status: 0,
        com_provinceid: 0,
        com_cityid: 0,
        com_areaid: 0,
        is_status: 0,
        keyword: '',
        page: 1,
        pagesize: 10
      },
      dakaihuiyuanxiangqing: false,
      form: {},
      huiyuanID: null,
      huiyuanxq: {}
    }
  },
  created () {
    this.list()
  },
  methods: {
    changList (val) {
      this.mingpianQuery.com_provinceid = val[0]
      this.mingpianQuery.com_cityid = val[1]
      this.mingpianQuery.com_areaid = val[2]
      this.Discountsearch()
    },
    async lazyLoad (node, resolve) {
      const level = node.level
      let result
      let res
      let param
      switch (level) {
        case 0: // 一级
          res = await province()
          result = res.data.list
          result.forEach((item) => {
            item.value = item.province_id
            item.label = item.province_name
          })
          break
        case 1: // 二级
          console.log(node.data.province_id)
          param = {
            province_id: node.data.province_id
          }
          res = await city(
            param
          )
          result = res.data.list
          // console.log(result)
          result.forEach((item) => {
            item.value = item.city_id
            item.label = item.city_name
          })
          break
        case 2: // 三级目录
          console.log(node.data.city_id)
          param = {
            city_id: node.data.city_id
          }
          res = await area(
            param
          )
          result = res.data.list
          result.forEach((item) => {
            item.value = item.area_id
            item.label = item.area_name
            item.leaf = level >= 2
          })
          break
        // case 3: // 三级目录
        //   param = {
        //     area_id: node.data.area_id
        //   }
        // res = await getStreet(
        //   param
        // )
        // result = res.list
        // result.forEach((item) => {
        //   item.value = item.street_id
        //   item.label = item.short_name
        //   // 大于三级后不再显示后面的，到此结束
        //   item.leaf = level >= 3
        // })
        // break
        default:
          result = []
          break
      }
      console.log(result)
      resolve(result)
    },
    Discountsearch () {
      this.cur_page = 1
      this.list()
      this.pageshow = false// 让分页隐藏
      this.$nextTick(() => { // 重新渲染分页
        this.pageshow = true
      })
    },
    list () {
      cardlist(this.mingpianQuery).then(({ data: res }) => {
        console.log('res', res)
        this.tableData = res.list
        this.total = res.total
      })
    },
    handleSizeChange (val) {
      this.mingpianQuery.pagesize = val
      this.handleCurrentChange(this.mingpianQuery.page)
    },
    handleCurrentChange (val) {
      this.mingpianQuery.page = val
      cardlist(this.mingpianQuery).then(({ data: res }) => {
        console.log('res', res)
        this.tableData = res.list
        this.total = res.total
      })
    },
    huiyuanxiangqingccc (row) {
      console.log(row)
      const obj = {
        token: sessionStorage.getItem('token'),
        card_id: row.id
      }
      cardview(obj).then(({ data: res }) => {
        console.log('res', res)
        this.huiyuanxq = res
      })
      this.dakaihuiyuanxiangqing = true
    }
  }
}
</script>

<style lang="less">
.el-scrollbar__wrap{
  height: 200px ;
}
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display:flex;
    flex-direction: row;
    align-items: center;
    .fansk{
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf{
      color: #3D9AFF;
    }
  }
  .btnsearch{
    display:flex;
    flex-direction: row;
    align-items: center;
    .left{
      flex: 1;
      margin-right: 150px;
      .btn{
        width: 124px;
        height: 43px;
        opacity: 1;
        background: linear-gradient(135deg,#1bb745, #17ab3f);
        border-radius: 5px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        letter-spacing: 0px;
        border: none;
        background: white;
      }
    }
    .right{
      margin-top: 27px;
    }
  }
  .huiyuananniu{
    background: white;
    width: 78px;
    height: 37px;
    opacity: 1;
    border: 1px solid rgba(61,154,255,0.50);
    border-radius: 2px;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #3d9aff;
    letter-spacing: 0px;
    display:flex;
    justify-content: center;
    align-items: center;
  }
  .rowLE{
    padding-top: 33px;
    padding-left: 60px;
  }
  .headetrxsadf{
    display:flex;
    flex-direction: row;
    height: 134px;
    align-items: center;
    .leftdsss{
      display:flex;
      flex-direction: row;
      align-items: center;
      flex:1;
      .titleddss{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Heavy;
        font-weight: 800;
        //text-align: left;
        color: #2e2e2e;
        .idss{
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Heavy;
          font-weight: 800;
          //text-align: left;
          color: #2e2e2e;
        }
      }
    }
    .right{
      display:flex;
      flex-direction: row;
      align-items: center;
      .huiyuanzhuangtai{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Heavy;
        font-weight: 800;
        text-align: left;
        color: #a1a1a1;
        margin-right: 8px;
        .sdadwee{
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Heavy;
          font-weight: 800;
          text-align: left;
          color: #e54848;
        }
        .sadgggvv{
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Heavy;
          font-weight: 800;
          text-align: left;
          color: #0FA838;
        }
        .sadccv{
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Heavy;
          font-weight: 800;
          text-align: left;
          color: #A1A1A1;
        }
      }
    }
  }
}
</style>
